import classNames from 'classnames';
import React, { FC } from 'react';
import { IllustrationType } from '../../enums/IllustrationType';

interface IllustrationProps{
    img: IllustrationType;
    className?: string;
    alt?: string;
}

const Illustration: FC<IllustrationProps> = ({
    img,
    className,
    alt = "",
}) => {

    return (
        <img
            className={classNames(
                className && className 
            )}
            // src={`/${process.env.PUBLIC_URL}imgs/illustrationsNew/${img}.svg`}
            src={`${process.env.REACT_APP_URL}imgs/illustrationsNew/${img}.svg`}
            alt={alt}
        />
    );
}
export default Illustration;